<template>
	<div
		class="order-navigation">
		<div
			v-for="t in tabs"
			class="order-navigation-button"
			v-bind:class="{
				active: tab == t.id,
				finished: finished[t.id],
				disabled: disabled[t.id],
			}"
			v-on:click="setTab(t.id)">
			<div>
				<SvgIcon
					:name="t.icon" />
				<div class="name">{{ t.name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      required: true
    }
  },
  data: () => ({
    tabs: [
      {
        id: '',
        name: 'General',
        icon: 'order'
      },
      {
        id: 'products',
        name: 'Products',
        icon: 'product'
      },
      {
        id: 'outbound',
        name: 'Outbound',
        icon: 'outbound'
      },
      {
        id: 'shipping',
        name: 'In transit',
        icon: 'shipping'
      },
      {
        id: 'return',
        name: 'Return',
        icon: 'return'
      },
      {
        id: 'payment',
        name: 'Payment',
        icon: 'payment-plan'
      }
    ]
  }),
  computed: {
    tab: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    },
    finished () {
      var list = {
        '': this.data.order_lines.length > 0,
        products: this.data.order_lines.length > 0,
        outbound: this.data.shipment.trackings.length > 0,
        shipping: this.data.shipment.trackings.length > 0,
        return: !!this.data.return.record
      }

      return list
    },
    disabled () {
      var list = {
        outbound: false,
        shipping: this.data.order_lines.length == 0,
        return: this.data.order_lines.length == 0,
        payment: this.data.shipment.trackings.length == 0
      }

      return list
    }
  },
  methods: {
    autoSelect () {
      if (this.data.order_lines.length == 0) {
        this.setTab('products')
      } else {
        this.setTab('outbound')
      }

      if (this.data.shipment.trackings.length > 0) {
        this.setTab('shipping')
      }
    },
    setTab (tab) {
      if (this.disabled[tab]) {
        return
      }

      this.tab = tab
    }
  },
  created () {
    this.autoSelect()
  }
}
</script>

<style lang="less">
	@line-size: 25px;
	@order-nav-border-color: #ddd;
	@green: #087BB9; //#4BB400;
	@blue: #0258B1;

	.order-navigation {
		display: flex;
		justify-content: center;
		padding-bottom: 30px;
		.order-navigation-button {
			position: relative;
			border: 2px solid @order-nav-border-color;
			border-radius: 50%;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;

			margin-left: @line-size;
			margin-right: @line-size;

			transition: 200ms;

			height: 60px;
			width: 60px;
			&.finished {
				border-color: @blue;
				svg {
					fill: @blue;
				}
				&::after {
					background: @blue;
				}
				&::before {
					background: @blue;
				}

				// background: linear-gradient(45deg, lighten(@green, -10%), lighten(@green, 0%));
				// svg {
				// 	fill: #fff;
				// }
			}
			&.active {
				transform: scale(1.1, 1.1);
				border-radius: 20%;
			}
			&.disabled {
				cursor: not-allowed;
				color: #999;
				svg {
					fill: #999;
				}
			}
			svg {
				fill: #555;
			}
			.svg-icon, svg {
				width: 36px !important;
				height: 36px !important;
			}
			.name {
				transition: 200ms;
				position: absolute;
				bottom: -30px;
				left: 0px;
				right: 0px;
				text-align: center;
			}
			&::after, &::before {
				position: absolute;
				width: @line-size;
				background: @order-nav-border-color;
				height: 3px;
				content: "";
			}
			&::before {
				left: -@line-size - 2px;
			}
			&::after {
				width: @line-size + 1px;
				left: ~"calc(100% + 2px)";
			}
			&:first-child {
				&::before {
					display: none;
				}
			}
			&:last-child {
				&::after {
					display: none;
				}
			}
		}
		.order-navigation-button:not(.active) {
			.name {
				pointer-events: none;
				opacity: 0;
				transform: translate(0px, 20px);
			}
		}

		&:hover {
			.order-navigation-button {
				.name {
					opacity: 1;
					transform: none;
				}
			}
		}
	}
</style>
